angular.module('FlexyBeautyApp.services')
    .constant('NfConstant', {
        CODE_10: {"value": "10", "label": "Accès à la piste d’audit"},
        CODE_20: {"value": "20", "label": "Archivage fiscal de période"},
        CODE_30: {"value": "30", "label": "Archivage fiscal d'exercice"},
        CODE_40: {"value": "40", "label": "Arrêt du terminal"},
        CODE_50: {"value": "50", "label": "Clôture de période"},
        CODE_60: {"value": "60", "label": "Clôture d'exercice"},
        CODE_70: {"value": "70", "label": "Début mode dégradée"},
        CODE_80: {"value": "80", "label": "Démarrage du terminal"},
        CODE_90: {"value": "90", "label": "Détection d’un défaut d’intégrité"},
        CODE_100: {"value": "100", "label": "Exécution Fonction spéciale"},
        CODE_110: {"value": "110", "label": "Export de données"},
        CODE_120: {"value": "120", "label": "Fin mode dégradée"},
        CODE_130: {"value": "130", "label": "Habilitation d’utilisateurs"},
        CODE_140: {"value": "140", "label": "Importation de données"},
        CODE_150: {"value": "150", "label": "Imprimante indisponible"},
        CODE_160: {"value": "160", "label": "La génération des écritures comptables"},
        CODE_170: {"value": "170", "label": "Le traitement de fond de caisse"},
        CODE_180: {"value": "180", "label": "Le transfert en comptabilité"},
        CODE_190: {"value": "190", "label": "Les annulations « comptables » de ticket"},
        CODE_200: {"value": "200", "label": "Purge"},
        CODE_210: {"value": "210", "label": "Reprise de données d’autres logiciels"},
        CODE_220: {"value": "220", "label": "Restauration"},
        CODE_230: {"value": "230", "label": "Sauvegarde"},
        CODE_240: {"value": "240", "label": "Suivi des interventions de maintenance"},
        CODE_250: {"value": "250", "label": "Version du logiciel"},
        CODE_260: {"value": "260", "label": "Initialisation des données"},
        CODE_300: {"value": "300", "label": "Activation de paramètre autorisé et documenté"},
        CODE_320: {"value": "320", "label": "Abandons d'opération de vente non encore enregistrée"},
        CODE_323: {"value": "323", "label": "Suppression de ligne d'opération de vente non encore enregistrée"},
        CODE_410: {"value": "410", "label": "Evolution de paramètre de conformité aux règles"},
        CODE_910: {"value": "910", "label": "Les annulations « comptables » d'acompte"},
        CODE_999: {"value": "999", "label": "Fonction éditeurs"}
    });



// WEBPACK FOOTER //
// ./js/constants/NfConstants.js